import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import DeviceStatistics from "views/admin/devices"
import UserStatistics from "views/admin/users"
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import RTLDefault from "views/rtl/default";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
    MdHome,
    MdOutlineShoppingCart,
    MdBarChart,
    MdPerson,
    MdLock,
    MdDevices,
    MdOutlineDevices,
    MdOutlineDevicesOther,
    MdVerifiedUser,
    MdOutlineNaturePeople,
    MdPeople,
    MdApps,
    MdMobileScreenShare,
    MdOutlineAnalytics,
    MdPeopleOutline,
    MdOutlinePeopleOutline,
    MdOutlineVerifiedUser,
    MdOutlineSupervisedUserCircle,
    MdProductionQuantityLimits,
    MdDevicesOther,
    MdImportantDevices,
    MdDeviceHub,
    MdDeviceUnknown,
    MdNewReleases,
    MdAccessibilityNew,
    MdOpenInNew,
    MdCreateNewFolder,
    MdOutlineCreateNewFolder,
    MdFeedback, MdOutlineFeedback, MdOutlineSummarize,
} from "react-icons/md";
import SignUp from "./views/auth/SignUp";
import Verification from "./views/auth/Verification";
import ForgotPassword from "./views/auth/ForgotPassword";
import UserDetailsStatsTable from "./views/admin/users/components/UserDetailsStatsTable";
import {useUserAuth} from "./context/UserAuthContext";
import NewProduct from "./views/admin/product/newProduct";
import ProductCatalog from "./views/admin/product";
import Feedback from "./views/admin/feedback";

// const routes = [
//   {
//     name: "Main Dashboard",
//     layout: "/senze-2.0/admin",
//     path: "dashboard",
//     icon: <MdHome className="h-6 w-6" />,
//     component: <MainDashboard />,
//   },
//   /*{
//     name: "NFT Marketplace",
//     layout: "/admin",
//     path: "nft-marketplace",
//     icon: <MdOutlineShoppingCart className="h-6 w-6" />,
//     component: <NFTMarketplace />,
//     secondary: true,
//   },*/
//   {
//     name: "Device Analytics",
//     layout: "/senze-2.0/admin",
//     icon: <MdOutlineDevicesOther className="h-6 w-6" />,
//     path: "device",
//     component: <DeviceStatistics />,
//   },
//   {
//     name: "User Analytics",
//     layout: "/senze-2.0/admin",
//     icon: <MdPeople className="h-6 w-6" />,
//     path: "user",
//     component: <UserStatistics />,
//   },
// /*  {
//     name: "App Analytics",
//     layout: "/senze-2.0/admin",
//     icon: <MdMobileScreenShare className="h-6 w-6" />,
//     path: "app",
//     component: <UserStatistics />,
//   },*/
//   /*{
//     name: "Data Tables",
//     layout: "/admin",
//     icon: <MdBarChart className="h-6 w-6" />,
//     path: "data-tables",
//     component: <DataTables />,
//   },*/
//   {
//     name: "Profile",
//     layout: "/senze-2.0/admin",
//     path: "profile",
//     icon: <MdPerson className="h-6 w-6" />,
//     component: <Profile />,
//   },
//   {
//     name: "Sign In",
//     layout: "/auth",
//     path: "sign-in",
//     icon: <MdLock className="h-6 w-6" />,
//     component: <SignIn />,
//   },
//
//   {
//     name: "Sign Up",
//     layout: "/auth",
//     path: "sign-up",
//     icon: <MdLock className="h-6 w-6" />,
//     component: <SignUp />,
//   },
//   {
//     name: "Reset Password",
//     layout: "/auth",
//     path: "reset-password",
//     icon: <MdLock className="h-6 w-6" />,
//     component: <ForgotPassword />,
//   },
//   {
//     name: "OTP Verification",
//     layout: "/auth",
//     path: "verify-otp",
//     icon: <MdLock className="h-6 w-6" />,
//     component: <Verification />,
//   },
//  /* {
//     name: "RTL Admin",
//     layout: "/rtl",
//     path: "rtl",
//     icon: <MdHome className="h-6 w-6" />,
//     component: <RTLDefault />,
//   },*/
// ];


const routesFirmware = [
    // --- Dashboards ---
    {
        name: "Home",
        layout: "/admin",
        path: "/dashboard",
        icon: <MdHome className="h-6 w-6"/>,
        component: <MainDashboard/>,
    },
    {
        name: "Analytics",
        path: "/admin/analytics",
        icon: <MdOutlineAnalytics className=" h-6 w-6"/>,
        collapse: true,
        items: [
            {
                name: "Device Analytics",
                layout: "/admin/analytics",
                icon: <MdOutlineDevicesOther className="h-5 w-5"/>,
                path: "/device",
                component: <DeviceStatistics/>,
            },
            /*{
                name: "User Analytics",
                layout: "/senze-2.0/admin/analytics",
                icon: <MdPeople className="h-5 w-5"/>,
                path: "/user",
                component: <UserStatistics/>,
            },*/
        ]
    },
   /* {
        name: "Users",
        path: "/senze-2.0/admin/stats",
        icon: <MdPeopleOutline className=" h-6 w-6"/>,
        collapse: true,
        items: [
            {
                name: "Users Overview",
                layout: "/senze-2.0/admin/stats",
                icon: <MdOutlineSupervisedUserCircle className="h-5 w-5"/>,
                path: "/details-user",
                component: <UserDetailsStatsTable/>,
            },
            /!*{
                name: "User Access",
                layout: "/senze-2.0/admin/users",
                icon: <MdOutlineVerifiedUser className="h-5 w-5"/>,
                path: "/user-access",
                component: <UserAclDetailsTable/>,
            },*!/
        ]
    },*/

    {
        name: "Products",
        path: "/admin/products",
        icon: <MdImportantDevices className=" h-6 w-6"/>,
        collapse: true,
        items: [
            {
                name: "Products Overview",
                layout: "/admin/products",
                icon: <MdDevicesOther className="h-5 w-5"/>,
                path: "/products-overview",
                component: <ProductCatalog/>,
            },
            /*{
                name: "New Product",
                layout: "/senze-2.0/admin/products",
                icon: <MdOutlineCreateNewFolder className="h-5 w-5"/>,
                path: "/new-product",
                component: <NewProduct/>,
            },*/
        ]
    },
    {
        name: "Feedback",
        path: "/admin/feedback",
        icon: <MdFeedback className=" h-6 w-6"/>,
        collapse: true,
        items: [
            {
                name: "Feedback",
                layout: "/admin/feedback",
                icon: <MdOutlineFeedback className="h-5 w-5"/>,
                path: "/feedback-overview",
                component: <Feedback/>,
            }
        ]
    },

    // --- NFTs ---
    // {
    // 	name: 'RTL Admin',
    // 	layout: '/rtl',
    // 	path: 'rtl-default',
    // 	// icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    // 	component: () => <MainDashboard /> RTL
    // }
];

export default routesFirmware;
